const width = 42;




const imageUplaodIcon = (props) => {
  return <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M34.4502 9.85458C33.8158 9.72808 33.2963 9.33133 33.028 8.76399C30.0572 2.49458 23.1706 -1.01101 16.2878 0.257828C10.0165 1.40783 5.10025 6.41416 4.05183 12.7181C3.74133 14.5792 3.76433 16.4422 4.11508 18.2572C4.23008 18.8495 3.97517 19.5088 3.45192 19.9842C1.25733 21.9794 0 24.8218 0 27.785C0 33.5963 4.72842 38.3267 10.5417 38.3267H31.625C39.5523 38.3267 46 31.879 46 23.9517C46 17.1187 41.1432 11.1886 34.4502 9.85458ZM31.625 34.4914H10.5417C6.8425 34.4914 3.83333 31.4822 3.83333 27.7831C3.83333 25.899 4.6345 24.0877 6.02983 22.8189C7.53633 21.4485 8.24358 19.4207 7.87558 17.5232C7.61108 16.1585 7.59575 14.7536 7.82958 13.3429C8.602 8.70074 12.3625 4.86933 16.974 4.02408C17.7119 3.88991 18.446 3.82474 19.1705 3.82474C23.6018 3.82474 27.6134 6.29533 29.5627 10.4066C30.3542 12.0779 31.8627 13.2471 33.6988 13.6132C38.6055 14.5926 42.1647 18.9396 42.1647 23.9517C42.1647 29.763 37.4344 34.4933 31.6231 34.4933L31.625 34.4914ZM28.9819 19.7197C29.7313 20.4691 29.7313 21.6804 28.9819 22.4298C28.6082 22.8036 28.1175 22.9914 27.6268 22.9914C27.1362 22.9914 26.6455 22.8036 26.2717 22.4298L23 19.1581V28.7414C23 29.8013 22.1413 30.6581 21.0833 30.6581C20.0253 30.6581 19.1667 29.8013 19.1667 28.7414V19.1581L15.8949 22.4298C15.1455 23.1792 13.9342 23.1792 13.1848 22.4298C12.4353 21.6804 12.4353 20.4691 13.1848 19.7197L18.3732 14.5312C19.113 13.7914 20.0847 13.4196 21.0565 13.4138L21.0833 13.4081L21.1102 13.4138C22.0838 13.4196 23.0537 13.7914 23.7935 14.5312L28.9819 19.7197Z"
      fill="#C5C5C5"
    />
  </svg>
}

export const Icons = {
  imageUplaodIcon,
};
